import ApiService from "@/common/api/api.service";

const ContratoDocumentacao = {

    salvarContratoDocumentacao(form) {
        return ApiService.post(`Projeto/contrato-documentacao-adicional`, form);
    },

    listarContratoDocumentacao(id) {
        return ApiService.get(`Projeto/contrato-documentacao-adicional?ProjetoId=${id}`);
    },
    
    excluirContratoDocumentacao(id) {
        return ApiService.delete(`Projeto/contrato-documentacao-adicional?id=${id}`);
    },

    baixarContratoDocumentacao(id) {
        return ApiService.downloadFile(`Projeto/contrato-documentacao-adicional/download-arquivo?id=${id}`);
    }

}

export default ContratoDocumentacao;
